class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (event) => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay && overlay.contains(event.target)) this.close();
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.open();
      this.mellowbyRefreshRecommendationCarousel();
      setTimeout(() => this.mellowbyRefreshRecommendationCarousel(), 600);
      setTimeout(() => this.mellowbyRefreshRecommendationCarousel(), 1400);
    });
  }

  mellowbyRecommendationHtml(html, cartIds) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrap = doc.querySelector('.cart-drawer__recs');
    if (!wrap) return null;

    const cards = Array.from(wrap.querySelectorAll('.cart-drawer__rec-card'));
    let kept = 0;
    cards.forEach((card) => {
      const productId = parseInt(card.getAttribute('data-product-id') || '0', 10);
      if (cartIds.indexOf(productId) === -1 && kept < 8) {
        card.removeAttribute('hidden');
        kept += 1;
      } else {
        card.remove();
      }
    });

    if (!kept) return null;
    wrap.classList.add('cart-drawer__recs--carousel');
    const title = wrap.querySelector('.cart-drawer__recs-title');
    if (title) title.textContent = 'Frequently Bought Together';
    return wrap.outerHTML;
  }

  async mellowbyRefreshRecommendationCarousel() {
    const slot = this.querySelector('[data-cart-recs]');
    if (!slot) {
      const existing = this.querySelector('.cart-drawer__recs');
      if (existing) {
        existing.classList.add('cart-drawer__recs--carousel');
        existing.querySelectorAll('.cart-drawer__rec-card').forEach((card) => card.removeAttribute('hidden'));
      }
      return;
    }

    const seed = slot.getAttribute('data-seed-product-id');
    const baseUrl = slot.getAttribute('data-section-url');
    if (!seed || !baseUrl) return;

    let cartIds = [];
    try {
      cartIds = JSON.parse(slot.getAttribute('data-cart-product-ids') || '[]');
    } catch (error) {
      cartIds = [];
    }

    const fetchIntent = async (intent) => {
      const response = await fetch(`${baseUrl}&intent=${intent}&product_id=${encodeURIComponent(seed)}`, {
        credentials: 'same-origin',
      });
      const html = await response.text();
      return this.mellowbyRecommendationHtml(html, cartIds);
    };

    try {
      const html = (await fetchIntent('complementary')) || (await fetchIntent('related'));
      if (html) slot.innerHTML = html;
    } catch (error) {
      // Leave the server-rendered slot untouched if recommendations fail.
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends (typeof CartItems !== 'undefined' ? CartItems : HTMLElement) {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
